<ng-container *ngFor="let mi of menuItems; index as i">
	<mat-card
		id="app-menu-header-{{ mi.indexId }}"
		class="app-menu-header"
		(click)="$event.stopPropagation()"
		*ngIf="mi.header"
	>
		<!-- Display Icon -->
		<!--<app-db-icon id="app-menu-item-{{mi.indexId}}-icon" class="app-menu-item-icon mr-sm" [iconId]="mi.iconId" [fixedWidth]="true"></app-db-icon>-->
		<!-- Display Text-->
		<span id="app-menu-header-{{ mi.indexId }}-title">{{ mi.title }}</span>
	</mat-card>

	<ng-container *ngIf="!mi.header">
		<!-- Parent Button -->
		<ng-container *appCondition="[mi.conditions, mi.conditionEntities, globalConditionEntities]">
			<!-- Parent with no child (for role) -->
			<ng-container *appPermissionId="mi.permissionId">
				<a
					*ngIf="mi.childMenu == null && [mi, globalConditionEntities]"
					id="app-menu-item-{{ mi.indexId }}"
					class="app-menu-item bg-{{ 800 - 100 * nestLevel }}"
					[attr.role]="'link'"
					[title]="getMenuTitle(mi)"
					[style]="menuPaddingStyle"
					[ngClass]="{ 'active-item': getActiveMenuItem() === mi.indexId && !mi.childMenu }"
					mat-menu-item
					(click)="miClicked(mi, $event)"
					(keyup.enter)="miClicked(mi, $event)"
					[disabled]="mi.expanded && mi.disableCollapse"
				>
					<div fxLayout="row">
						<div class="app-menu-label" fxLayout="row">
							<div class="app-menu-label-shell">
								<!-- Display Text-->
								<span
									class="app-menu-label-title"
									id="app-menu-item-{{ mi.indexId }}-title"
									[ngClass]="{ 'no-child': !mi.childMenu }"
								>
									{{ mi.title }}
								</span>

								<!--<app-db-icon style="float:right" class="app-menu-item-icon mr-sm" [fixedWidth]="true" *ngIf="mi.documentationRequired" [iconId]="394" [matTooltip]="'Documentation is required to complete this case action'"></app-db-icon>-->

								<span
									class="app-menu-label-count"
									*ngIf="mi.count"
									id="app-menu-item-{{ mi.indexId }}-count"
								>
									({{ mi.count }})
								</span>
							</div>
						</div>

						<div class="app-menu-icons">
							<!-- Star Icon -->
							<fa-icon
								tabindex="0"
								*ngIf="mi.favorited === false"
								style="line-height: 60px"
								id="app-menu-item-{{ mi.indexId }}-star-favorite"
								[icon]="$any(['fass', 'star'])"
								class="app-menu-star-icon"
								(click)="toggleFavorite(mi, $event)"
								(keyup.enter)="toggleFavorite(mi, $event)"
								attr.aria-label="Add {{ mi.title }} to Favorites"
								[attr.role]="'button'"
							></fa-icon>

							<fa-icon
								tabindex="0"
								*ngIf="mi.favorited === true"
								style="line-height: 60px"
								id="app-menu-item-{{ mi.indexId }}-star-favorite"
								[icon]="$any(['fass', 'star'])"
								[ngClass]="{ favorited: mi.favorited === true }"
								class="app-menu-star-icon"
								(click)="toggleFavorite(mi, $event)"
								(keyup.enter)="toggleFavorite(mi, $event)"
								attr.aria-label="Remove {{ mi.title }} from Favorites"
								[attr.role]="'button'"
							></fa-icon>
						</div>
					</div>
				</a>

				<!-- Parent with child (for role) -->
				<a
					*ngIf="mi.childMenu != null && [mi, globalConditionEntities]"
					id="app-menu-item-{{ mi.indexId }}"
					class="app-menu-item bg-{{ 800 - 100 * nestLevel }}"
					[attr.role]="'button'"
					[attr.aria-expanded]="mi.expanded"
					[title]="getMenuTitle(mi)"
					[style]="menuPaddingStyle"
					[ngClass]="{ 'active-item': getActiveMenuItem() === mi.indexId && !mi.childMenu }"
					mat-menu-item
					(click)="miClicked(mi, $event)"
					(keyup.enter)="miClicked(mi, $event)"
					[disabled]="mi.expanded && mi.disableCollapse"
				>
					<div fxLayout="row">
						<div class="app-menu-label" fxLayout="row">
							<div class="app-menu-label-shell">
								<!-- Caret Icon -->

								<fa-icon
									*ngIf="mi.expanded === false && mi.childMenu && allowLabelToggle"
									id="app-menu-item-{{ mi.indexId }}-caret"
									[icon]="$any(['fass', 'caret-right'])"
									class="app-menu-caret-icon"
								></fa-icon>

								<fa-icon
									*ngIf="mi.expanded === true && mi.childMenu && allowLabelToggle"
									id="app-menu-item-{{ mi.indexId }}-caret"
									[icon]="$any(['fass', 'caret-down'])"
									class="app-menu-caret-icon"
								></fa-icon>

								<!-- Display Text-->
								<span
									class="app-menu-label-title"
									id="app-menu-item-{{ mi.indexId }}-title"
									[ngClass]="{ 'no-child': !mi.childMenu }"
								>
									{{ mi.title }}
								</span>

								<!--<app-db-icon style="float:right" class="app-menu-item-icon mr-sm" [fixedWidth]="true" *ngIf="mi.documentationRequired" [iconId]="394" [matTooltip]="'Documentation is required to complete this case action'"></app-db-icon>-->

								<span
									class="app-menu-label-count"
									*ngIf="mi.count"
									id="app-menu-item-{{ mi.indexId }}-count"
								>
									({{ mi.count }})
								</span>
							</div>
						</div>

						<div class="app-menu-icons">
							<!-- Star Icon -->
							<fa-icon
								tabindex="0"
								*ngIf="mi.favorited === false"
								style="line-height: 60px"
								id="app-menu-item-{{ mi.indexId }}-star-favorite"
								[icon]="$any(['fass', 'star'])"
								class="app-menu-star-icon"
								(click)="toggleFavorite(mi, $event)"
								(keyup.enter)="toggleFavorite(mi, $event)"
								attr.aria-label="Add {{ mi.title }} to Favorites"
								[attr.role]="'button'"
							></fa-icon>

							<fa-icon
								tabindex="0"
								*ngIf="mi.favorited === true"
								style="line-height: 60px"
								id="app-menu-item-{{ mi.indexId }}-star-favorite"
								[icon]="$any(['fass', 'star'])"
								[ngClass]="{ favorited: mi.favorited === true }"
								class="app-menu-star-icon"
								(click)="toggleFavorite(mi, $event)"
								(keyup.enter)="toggleFavorite(mi, $event)"
								attr.aria-label="Remove {{ mi.title }} from Favorites"
								[attr.role]="'button'"
							></fa-icon>
						</div>
					</div>
				</a>
			</ng-container>

			<!-- Child Menu If Applicable -->
			<application-menu-menu-items-list
				[globalConditionEntities]="globalConditionEntities"
				id="app-menu-item-{{ mi.indexId }}-child-menu"
				[menuConfig]="mi.childMenu"
				[paddingPx]="paddingPx"
				[nestLevel]="nestLevel + 1"
				[allowLabelToggle]="allowLabelToggle"
				class="child-menu bg-{{ 800 - 100 * nestLevel }}"
				*ngIf="mi.childMenu && mi.childMenu.length > 0 && mi.expanded"
				(menuItemClicked)="menuItemClicked.emit($event)"
				(menuUpdatedEvent)="menuUpdated()"
			></application-menu-menu-items-list>

			<mat-divider *ngIf="mi.addDivider"></mat-divider>
		</ng-container>
	</ng-container>
</ng-container>

<ng-container *ngIf="noActionsAvailable">
	<button mat-menu-item>No Actions Available</button>
</ng-container>
